// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb__1gWfP","breadcrumbList":"styles_breadcrumbList__2CBd0","item":"styles_item__3fzxI","navNext":"styles_navNext__28Sp-"};